(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cinematic-parallax"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const scenes = document.querySelectorAll('[data-parallax-scene]');
    if (!scenes.length) return;

    // Parallax scroll effect (desktop only)
    if (!isMobile) {
      let ticking = false;
      function updateParallax() {
        const scrollY = window.scrollY;
        scenes.forEach(scene => {
          const rect = scene.getBoundingClientRect();
          const sceneTop = rect.top + scrollY;
          const speed = parseFloat(scene.getAttribute('data-speed')) || 0.4;
          
          // Check if scene is near viewport
          if (scrollY + window.innerHeight + 200 < sceneTop || scrollY - 200 > sceneTop + rect.height) return;
          
          const media = scene.querySelector('.parallax-media, .parallax-video');
          if (media && !media.classList.contains('ken-burns') && !media.classList.contains('ken-burns-pan')) {
            // Apply parallax shift only if not Ken Burns (or video)
            const relativeScroll = scrollY - sceneTop;
            const yOffset = relativeScroll * speed;
            media.style.transform = `translateY(${yOffset * 0.3}px)`;
          }
        });
        ticking = false;
      }
      
      window.addEventListener('scroll', () => {
        if (!ticking) {
          requestAnimationFrame(updateParallax);
          ticking = true;
        }
      });
      updateParallax();
    }

    // Ensure videos play (autoplay policy)
    const videos = document.querySelectorAll('.parallax-video');
    videos.forEach(video => {
      video.play().catch(e => console.log('Video autoplay blocked:', e));
    });

    // Text fade-in on scroll (all devices)
    const textElements = document.querySelectorAll('[data-parallax-content]');
    const textObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        } else {
          entry.target.classList.remove('visible');
        }
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });
    
    textElements.forEach(el => textObserver.observe(el));
    
    // Initial visible check
    setTimeout(() => {
      textElements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100 && rect.bottom > 100) {
          el.classList.add('visible');
        }
      });
    }, 200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // ---------- PARALLAX (desktop only) ----------
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (!isMobile) {
      const parallaxBlocks = document.querySelectorAll('[data-parallax-block]');
      
      function updateParallax() {
        parallaxBlocks.forEach(block => {
          const bg = block.querySelector('[data-parallax-bg]');
          if (!bg) return;
          const speed = parseFloat(block.getAttribute('data-speed')) || 0.5;
          const rect = block.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          // Only transform when block is in or near viewport
          if (rect.top < windowHeight + 200 && rect.bottom > -200) {
            const scrolled = window.scrollY;
            const blockTop = block.offsetTop;
            const yPos = (scrolled - blockTop) * speed;
            bg.style.transform = `translateY(${yPos * 0.3}px)`;
          }
        });
        requestAnimationFrame(updateParallax);
      }
      
      window.addEventListener('scroll', () => {
        requestAnimationFrame(updateParallax);
      });
      updateParallax();
    }

    // ---------- TEXT FADE IN ON SCROLL (all devices) ----------
    const contentElements = document.querySelectorAll('[data-parallax-content]');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        } else {
          // Optional: remove class if you want re-triggering (default keeps visible)
          // entry.target.classList.remove('visible');
        }
      });
    }, { threshold: 0.2 });
    
    contentElements.forEach(el => observer.observe(el));
    
    // Force first visible items to appear on load
    setTimeout(() => {
      contentElements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100) {
          el.classList.add('visible');
        }
      });
    }, 100);
  });

  } catch(e) { console.error(e); }
})();
})();
